import { createContext } from 'react';

export const PostAuthRedirectContext = createContext({
  redirectAfterTo: '',
  consumePostAuthRedirect: (defaultPath) => defaultPath,
});
